import gql from 'graphql-tag'

export const addConsultant = gql`
  mutation DooerComConsultant($input: ConsultantInput!) {
    consultants {
      create(input: $input) {
        id
      }
    }
  }
`

export const getCategories = gql`
  query DooerComGetConsultantCategories {
    consultantCategories(first: -1) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`
